/* src/app/components/login/login.component.css */
.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  padding: 32px 28px 30px;
}
.status-text {
  margin: 0;
  color: var(--fg-2);
  font-size: 0.95rem;
  line-height: 1.5;
}
.spinner {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 3px solid var(--border);
  border-top-color: var(--navy-600);
  animation: login-spin 0.8s linear infinite;
}
@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}
.status-icon--error {
  color: var(--danger-strong);
}
.status-icon--disabled {
  color: var(--warning);
}
.btn-retry {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  background: var(--navy-600);
  color: var(--bg-surface);
  font-size: 0.9rem;
  font-weight: 600;
  padding: 9px 18px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.btn-retry:hover {
  background: var(--navy-700);
}
.btn-retry:focus-visible {
  outline: 2px solid var(--navy-600);
  outline-offset: 2px;
}
/*# sourceMappingURL=login.component.css.map */
